import React, { useState } from "react";

import { Grid } from "@mui/material";

import { QuickAccessMenu } from "./QuickAccessMenu";
import { useUserContext } from "contexts/UserContext";
import { Header } from "components/libComponents/Header";
import { SideMenu } from "components/libComponents/SideMenu";

export const SectionWrapper = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const { hasProsumer } = useUserContext();

  const handleMenuToggle = () => setIsMenuOpen((prevState) => !prevState);
  const handleClosing = () => setIsMenuOpen(false);

  return (
    <>
      <SideMenu
        open={isMenuOpen}
        onClose={handleClosing}
        isProsumer={hasProsumer}
      />
      <Header onDrawerToggle={handleMenuToggle} />
      <Grid
        container
        direction="column"
        wrap="nowrap"
        sx={{ overflowY: "scroll", gridArea: "main" }}
      >
        <Grid
          container
          component="main"
          sx={{ bgcolor: "backgrounds.primary", flex: 1 }}
        >
          {children}
        </Grid>
      </Grid>
      <QuickAccessMenu />
    </>
  );
};
